import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Exhibitor } from '@planone/bau365/util-fair-data';

@Component({
  selector: 'bau365-exhibitor-section-contact-persons',
  templateUrl: './section-contact-persons.component.html',
  styleUrls: ['./section-contact-persons.component.scss'],
})
export class SectionExhibitorContactPersonsComponent {
  @Input() exhibitor?: Exhibitor;
  @Input() size?: string;
  @Input() contactClickable = true;

  @Output() linkClick: EventEmitter<{
    element: EventTarget | null;
    linkType: string;
    contactPersonId?: string;
    linkText?: string;
  }> = new EventEmitter<{
    element: EventTarget | null;
    linkType: string;
    contactPersonId?: string;
    linkText?: string;
  }>();

  trackClick = (
    element: EventTarget | null,
    linkType: string,
    linkText: string | undefined = undefined,
    contactPersonId: string | undefined = undefined
  ) => this.linkClick.emit({ element, linkType, contactPersonId, linkText });
}
